import Routes from './routes';
import Theme from './styles/theme';
import { Provider } from 'react-redux';
import initStore from './redux/store';
import { SnackbarProvider } from 'notistack';
import { useEffect, useRef } from 'react';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { MsalProvider, useMsal } from '@azure/msal-react';

export const store = initStore({});

const App = ({ instance }) => {
    const stackRef = useRef(null);

    const onClose = (key) => () => {
        stackRef.current.closeSnackbar(key);
    };

    return (
        <SnackbarProvider
            ref={stackRef}
            dense
            maxSnack={1}
            preventDuplicate
            autoHideDuration={3000}
            variant="success" // Set default variant
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            // With close as default
            action={(key) => (
                <IconButton size="small" color="inherit" onClick={onClose(key)} sx={{ p: 0.5 }}>
                    <Close />
                </IconButton>
            )}
        >
            <MsalProvider instance={instance}>
                <Provider store={store}>
                    <Theme>
                        <Routes />
                    </Theme>
                </Provider>
            </MsalProvider>
        </SnackbarProvider>
    );
};

export default App;
